require('./ProgramEpisodes_Modal.scss');

const _ = {
    debounce: require('lodash/debounce'),
};

const b = require('app/www/libs/b')('program-episodes-modal');
const bPage = require('app/www/libs/b')('page');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');
const {buildYStatFromBlock} = require('app/common/libs/streamChannel');

const Button = require('app/www/components/blocks/Button/Button');
const Global = require('app/www/components/blocks/Global/Global');
const Icon = require('app/www/components/blocks/Icon/Icon');
const Tabs = require('app/www/components/blocks/Tabs/Tabs');
const Video = require('app/www/components/blocks/Video/Video');
const Ua = require('app/www/components/blocks/Ua/Ua');

const SCROLL_TIMEOUT = 50;
const VIDEO_ASPECT_RATIO = 1.8;
const TOP_OFFSET = 60;

class ProgramEpisodes_Modal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            scrolled: false,
        };

        if (Global.isClient) {
            this._page = document.querySelector('.page');
            this._pageClass = bPage.mod({modal: true});
        }

        this._onScroll = _.debounce(this._onScroll.bind(this), SCROLL_TIMEOUT, {
            leading: true,
            trailing: true,
        });
        this._onClick = this._onClick.bind(this);
    }

    componentDidMount() {
        this._page.classList.add(this._pageClass);
    }

    componentWillUnmount() {
        this._page.classList.remove(this._pageClass);
    }

    render() {
        const {scrolled} = this.state;
        const {
            i18n,
            episodes,
            tabsItems,
            hasSeasons,
            onTabChange,
            firstEpisode,
            programTitle,
            selectedSeason,
            selectedEpisode,
            onSelectEpisode,
            getEpisodeTitles,
            hasMoreThanOneEpisode,
        } = this.props;

        const buttonCloseProps = {
            className: b('close'),
            onClick: onSelectEpisode(null),
            mods: {
                size: 'xs',
                'only-icon': true,
            },
            icon: {
                close: true,
                white: true,
                size: 'm',
            },
        };

        const embedUrl = selectedEpisode && selectedEpisode.embedUrl;

        const videoProps = {
            allowFullScreen: true,
            height: Ua.displayWidth ? Ua.displayWidth / VIDEO_ASPECT_RATIO : '100%',
            width: '100%',
            src: embedUrl
                ? `${embedUrl}&${buildYStatFromBlock('programpage', Ua.isTouchPhone)}`
                : '',
        };

        const playIconProps = {
            mods: {
                play: true,
                size: 'm',
            },
        };

        const tabsProps = {
            mods: {
                dark: true,
            },
            items: hasSeasons && tabsItems,
            selectedId: selectedSeason,
            onChange: onTabChange,
        };

        const {title: currentTitle, subtitle: currentSubtitle} = getEpisodeTitles(selectedEpisode || firstEpisode);

        return [
            <div key="header" className={b('header', {scrolled})}>
                <div className={b('header-title')}>{programTitle}</div>
                <Button {...buttonCloseProps} />
            </div>,
            <div key="content" className={b()} onScroll={this._onScroll}
                ref={ref => (this.node = ref)}>
                <div className={b('content', {'single-episode': !hasMoreThanOneEpisode})} ref={ref => (this._content = ref)}>
                    {selectedEpisode && (
                        <Video className={b('video')} {...videoProps} />
                    )}
                    {!selectedEpisode && (
                        <div className={b('video-image-wrapper')} onClick={onSelectEpisode(firstEpisode)}>
                            <img src={firstEpisode.thumbnail} className={b('video-image')} />
                            <div className={b('video-play-button')}>
                                <Icon {...playIconProps} />
                            </div>
                        </div>
                    )}
                    {hasMoreThanOneEpisode && [
                        <div key="title" className={b('title')}>{currentTitle}</div>,
                        <div key="subtitle" className={b('subtitle')}>{currentSubtitle}</div>,
                        hasSeasons && (
                            <Tabs key="tabs" {...tabsProps} />
                        ),
                        <div key="items" className={b('items-list')}>
                            {episodes.map(episode => {
                                const isSelected = episode === selectedEpisode;
                                const {title, subtitle} = getEpisodeTitles(episode);

                                let onClick = null;

                                if (!isSelected) {
                                    onClick = this._onClick(episode);
                                }

                                return (
                                    <div key={episode.contentId} className={b('item', {selected: isSelected})} onClick={onClick}>
                                        <div className={b('item-thumbnail')} style={{backgroundImage: `url(${episode.thumbnail})`}}>
                                            {isSelected && (
                                                <div className={b('item-playing-now')}>{i18n.get('program-episodes.playing-now')}</div>
                                            )}
                                        </div>
                                        <div className={b('item-titles')}>
                                            <div className={b('item-title')}>{title}</div>
                                            {Boolean(subtitle) && <div className={b('item-subtitle')}>{subtitle}</div>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>,
                    ]}
                </div>
            </div>,
        ];
    }

    /**
     * @private
     */
    _onScroll() {
        const {top} = this._content.getBoundingClientRect();

        if (top < TOP_OFFSET) {
            this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    }

    /**
     * @private
     */
    _onClick(episode) {
        return (e) => {
            this.props.onSelectEpisode(episode)(e);
            this.node.scrollTo({
                behavior: 'smooth',
                left: 0,
                top: 0,
            });
        };
    }
}

ProgramEpisodes_Modal.propTypes = {
    tabsItems: PropTypes.array,
    hasSeasons: PropTypes.bool.isRequired,
    getEpisodeTitles: PropTypes.func.isRequired,
    hasMoreThanOneEpisode: PropTypes.bool.isRequired,
    programId: PropTypes.number.isRequired,
    programTitle: PropTypes.string.isRequired,
    selectedEpisode: PropTypes.object,
    firstEpisode: PropTypes.object,
    onSelectEpisode: PropTypes.func,
    episodes: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            duration: PropTypes.number,
            embedUrl: PropTypes.string.isRequired,
            contentId: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            uploadDate: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            seasonNumber: PropTypes.number,
            episodeNumber: PropTypes.number,
            isFamilyFriendly: PropTypes.bool.isRequired,
        })
    ),
};

module.exports = withI18n(ProgramEpisodes_Modal);
